import { render } from "./Myschool.vue?vue&type=template&id=eb3f5810"
import script from "./Myschool.vue?vue&type=script&lang=js"
export * from "./Myschool.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Myschool.vue?vue&type=style&index=0&id=eb3f5810&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__